import {combineReducers, createStore} from "redux";
//import thunkMiddleWare from "redux-thunk";
import flowReducer from "./flow-reducer";
import userDataReducer from "./userdata-reducer";
import teamReducer from "./team-reducer";
import reportReducer from "./report-reducer";

let reducers = combineReducers({
    flow:flowReducer,
    userData:userDataReducer,
    team:teamReducer,
    report:reportReducer,
});

let store = createStore(reducers);

export default store;